import * as formWizardConstants from './constants';

/**
 * Gets the panel associated with a panel ID
 *
 * @param {Element} formWizard
 * @param {String} panelId
 */
export default function getPanelById(formWizard, panelId) {
  if (!formWizard || !panelId) return;
  return formWizard.querySelector(
    `${formWizardConstants.selectors.panel}[data-id="${panelId}"]`
  );
}
